module.exports = __webpack_public_path__ + "media/images/AppClipSign-183fb27f12fab459137dd55606edf5ce.JPG";